import { useMemo } from 'react';
import { formatToDate } from 'utils/formatToDate';

import TableCellWithPublicationStatus from 'components/TableCellWithPublicationStatus';
import { useAuthenticatedContext } from 'hooks/useAuthenticated';
import useCertificateHelper from 'hooks/useCertificateHelper';
import { ADDITIONAL_DETAILS, NESTED_DETAILS } from 'models/certificate.model';
import { COMPANY } from 'models/company.model';
import { CATEGORY_TYPE } from 'models/documents.model';

import { BatteryCellsPageTabsEnum, BatteryPacksPageTabsEnum } from '../../constants';

const useTableConfig = () => {
  const { currentUser } = useAuthenticatedContext();
  const { getLabel } = useCertificateHelper();

  const config = useMemo<any>(() => {
    switch (currentUser?.company) {
      case COMPANY.BATTERY_CELLS:
      default:
        return {
          creationEnabledByTabs: {
            [BatteryCellsPageTabsEnum.SHIPPING_CONFIRMATION]: true,
          },
          categoryByTabs: {
            [BatteryCellsPageTabsEnum.SHIPPING_CONFIRMATION]:
              CATEGORY_TYPE.BATTERY_CELLS_SHIPPING_CONFIRMATION,
            [BatteryCellsPageTabsEnum.RECEIVING_CONFIRMATION]:
              CATEGORY_TYPE.BATTERY_CELLS_RECEIVING_CONFIRMATION,
          },
          configByTabs: {
            [BatteryCellsPageTabsEnum.SHIPPING_CONFIRMATION]: [
              {
                title: getLabel(ADDITIONAL_DETAILS.RECIPIENT),
                dataIndex: ['additionalDetails', ADDITIONAL_DETAILS.RECIPIENT],
                render: TableCellWithPublicationStatus,
              },
              {
                title: getLabel(NESTED_DETAILS.BATTERY_CELL_MODEL),
                dataIndex: ['additionalDetails', NESTED_DETAILS.BATTERY_CELL_MODEL],
              },
              {
                title: getLabel(NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER),
                dataIndex: ['additionalDetails', NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER],
              },
              {
                title: getLabel(ADDITIONAL_DETAILS.SHIPPING_DATE),
                dataIndex: ['additionalDetails', ADDITIONAL_DETAILS.SHIPPING_DATE],
                render: formatToDate,
              },
            ],
            [BatteryCellsPageTabsEnum.RECEIVING_CONFIRMATION]: [
              {
                title: getLabel(ADDITIONAL_DETAILS.ISSUER),
                dataIndex: ['additionalDetails', ADDITIONAL_DETAILS.ISSUER],
                render: TableCellWithPublicationStatus,
              },
              {
                title: getLabel(NESTED_DETAILS.BATTERY_CELL_MODEL),
                dataIndex: ['additionalDetails', NESTED_DETAILS.BATTERY_CELL_MODEL],
              },
              {
                title: getLabel(NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER),
                dataIndex: ['additionalDetails', NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER],
              },
              {
                title: getLabel(ADDITIONAL_DETAILS.RECEIVING_DATE),
                dataIndex: ['additionalDetails', ADDITIONAL_DETAILS.RECEIVING_DATE],
                render: formatToDate,
              },
            ],
          },
        };
      case COMPANY.BATTERY_PACKS:
        return {
          creationEnabledByTabs: {
            [BatteryPacksPageTabsEnum.CAR_DEALERS_SHIPPING_CONFIRMATION]: true,
          },
          categoryByTabs: {
            [BatteryPacksPageTabsEnum.CAR_DEALERS_SHIPPING_CONFIRMATION]:
              CATEGORY_TYPE.CAR_DEALERS_SHIPPING_CONFIRMATION,
          },
          configByTabs: {
            [BatteryPacksPageTabsEnum.CAR_DEALERS_SHIPPING_CONFIRMATION]: [
              {
                title: getLabel(ADDITIONAL_DETAILS.RECIPIENT),
                dataIndex: ['additionalDetails', ADDITIONAL_DETAILS.RECIPIENT],
                render: TableCellWithPublicationStatus,
              },
              {
                title: getLabel(NESTED_DETAILS.EVMODEL),
                dataIndex: ['additionalDetails', NESTED_DETAILS.EVMODEL],
              },
              {
                title: getLabel(NESTED_DETAILS.BATTERY_PACK_SERIAL_NUMBER),
                dataIndex: ['additionalDetails', NESTED_DETAILS.BATTERY_PACK_SERIAL_NUMBER],
              },
              {
                title: getLabel(ADDITIONAL_DETAILS.SHIPPING_DATE),
                dataIndex: ['additionalDetails', ADDITIONAL_DETAILS.SHIPPING_DATE],
                render: formatToDate,
              },
            ],
          },
        };
    }
  }, [currentUser?.company, getLabel]);

  return config;
};

export default useTableConfig;
